export default __webpack_public_path__ + "static/assets/e962bb14129d55b565bd1ebdebdf6cce.svg";